import { NewProcessAction } from "../actions/NewProcess";
import { IProcessData } from "../model/IProcessData";

export const NEW_PROCESS_FROM_TEMPLATE = "NEW_PROCESS_FROM_TEMPLATE";

export function processFromTemplate(): NewProcessAction {
  const templateJson = document.getElementById("processTemplateJson")?.innerText;
  const template: IProcessData = JSON.parse(templateJson as string);

  // Force id and version to the zero to indicate a new process
  template.id = 0;
  template.version = 0;

  return {
    type: NEW_PROCESS_FROM_TEMPLATE,
    processData: template
  };
}
